<template>
  <v-image
    ref="image"
    :config="{
      image: image.node,
      x: image.x,
      y: image.y,
      width: image.width,
      height: image.height,
    }">
  </v-image>
</template>



<script>
import Vue from 'vue';
import VueKonva from 'vue-konva'
Vue.use(VueKonva)

export default {
  props: [
    'data',
  ],
  data() {
    return {
      canvas: {
        width: 0,
        height: 0,
      },
      image: {
        image: null,
        cache: null,
        x: 0,
        y: 0,
        width: 0,
        height: 0,
      },
      filters: [Konva.Filters.Blur],
    }
  },
  watch: {
    data: {
      handler(val) {
        this.dataWatch()
      },
      deep: true
    },
  },
  updated() {
    this.$emit('updated')
  },
  beforeDestroy() {
    this.$emit('beforeDestroy')
  },
  created() {
    this.dataWatch()
  },
  methods: {
    gcd(a, b) {
      if (b === 0) return a
      return this.gcd(b, a % b)
    },
    canvasSize() {
      this.$set(this.canvas, 'width', this.image.width)
      this.$set(this.canvas, 'height', this.image.height)
      this.$emit('canvas', this.canvas)
    },
    dataWatch() {
      this.imageLoad()
    },
    imageLoad() {
      const image = new Image()
      image.src = this.data.src
      image.onload = () => {
        const width = image.naturalWidth * this.data.scale
        const height = image.naturalHeight * this.data.scale
        const x = this.data.x - width / 2
        const y = this.data.y - height

        this.$set(this.image, 'node', image)
        this.$set(this.image, 'cache', image)
        this.$set(this.image, 'width', width)
        this.$set(this.image, 'height', height)
        this.$set(this.image, 'x', x)
        this.$set(this.image, 'y', y)

        this.$nextTick(() => {
          if (this.data.soldout) {
            console.log('test');
            const node = this.$refs.image.getStage();
            node.cache()
            node.filters([
              Konva.Filters.Grayscale,
              Konva.Filters.Contrast,
              Konva.Filters.Brighten,
            ])
            node.contrast(-50)
            node.brightness(0.15)
          }
        })

        if (this.data.slug === 'stages') this.canvasSize()
      }
    },
  }
}
</script>
